import Vue from 'vue';

Vue.component(
    'vuetable_override_pricebook',
    require(/* webpackChunkName: 'override-index' */ './override-index.vue'),
);

Vue.component(
    'vuetable_override_pricebook_editor',
    require(/* webpackChunkName: 'override-editor' */ './override-editor.vue'),
);

Vue.component('override-ial', () =>
    import(/* webpackChunkName: 'override-ial' */ './override-ial.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/override_pricebook/index.js